<template>
  <div class="app-wrapper">
    <NavBar v-if="$route.name !== '404'"/>
    <div class="main-content">
      <router-view/>
    </div>
    <Footer v-if="$route.name !== '404'"/>
  </div>
</template>

<script>
import NavBar from '@/components/NavBar'
import Footer from '@/components/Footer'

export default {
  components: {
    NavBar,
    Footer
  }
}
</script>


